import React from "react";

const Button = props => {
  const { action, disabled, children, text } = props;
  let classList = "button";
  if (disabled) {
    classList += " disabled"
  }
  return (
    <button
      className={classList}
      type="button"
      onClick={() => action()}
    >
      {text && text.toUpperCase()}
      {!text && children && children.toUpperCase()}
      {!text && !children && 'INVIA'}
    </button>
  );
};

export default Button
